module.exports = __webpack_public_path__ + "static/media/tag-logo.ab5d166b.png";